import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type {
  ReportStepsQuery,
  StepsPerformanceResponse
} from '@eggplant/types'

interface Props {
  params?: ReportStepsQuery
  onSuccess?: (data: StepsPerformanceResponse) => void
  children?: (data: StepsPerformanceResponse) => ReactElement
}

const GetAiPerformanceRequest = ({
  params,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/reports/performance/steps`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default GetAiPerformanceRequest
